import { render } from "./ChurnAnalysis.vue?vue&type=template&id=faff855a&scoped=true"
import script from "./ChurnAnalysis.vue?vue&type=script&lang=js"
export * from "./ChurnAnalysis.vue?vue&type=script&lang=js"

import "./ChurnAnalysis.vue?vue&type=style&index=0&id=faff855a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faff855a"]])

export default __exports__